// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/less/chart.less
// module id = 515
// module chunks = 0